import React from 'react'
import { I18n } from 'react-redux-i18n'

/**
 * InputTextArea
 * @param {object} props
 * @param {String} props.id
 * @param {String} props.propName
 * @param {String} props.label
 * @param {String} props.value
 * @param {String} props.description
 * @param {Function} props.onChange
 * @param {String} props.height  // large, small
 */
const InputTextArea = (props) => {
  const { id, propName, label, value, description, onChange, height, limit, required } = props

  return (
    <div className={`channel-field input text-area text-area--${height}`}>
      {label && <label htmlFor={id}>{I18n.t(label)} <span className='required'>{required ? '*' : ''}</span></label>}
      <div className='field-content grid grid--large'>
        <textarea
          className={`text-area text-area--${height}`}
          id={id}
          name={propName}
          value={value}
          onChange={({ target }) =>onChange(target.value)}
          maxLength={limit}
        />
        {description && <p className='description'>{I18n.t(description)}</p>}
      </div>
    </div>
  )
}

export default InputTextArea
